import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

const listItemBase = style({
  position: "relative",
  selectors: {
    "&::after": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: "50%",
      transform: "translateX(-50%)",
      backgroundColor: vars.colors.outlineVariant,
      width: "50%",
      height: 1,
      content: "",
    },
  },
});

export const listItemStyles = styleVariants({
  default: [listItemBase],
  mine: [
    listItemBase,
    {
      background: vars.colors.blueBrandGradient,
      color: vars.colors.white,
      selectors: {
        "&::after": {
          content: "none",
        },
        '[dir="rtl"] &': {
          background: vars.colors.blueBrandGradientRtl,
        },
      },
    },
  ],
});

export const matchItemContent = style({
  display: "flex",
  flexDirection: "column-reverse",
  alignItems: "center",
  justifyContent: "space-between",
  gap: vars.space.s,
  padding: vars.space.m,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      flexDirection: "row",
      gap: 0,
    },
  },
  selectors: {
    [`${listItemStyles.mine} &`]: {
      backgroundColor: vars.colors.glass,
    },
  },
});

export const eventStyles = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.xs,
  selectors: {
    [`${listItemStyles.mine} &`]: {
      color: vars.colors.white,
    },
  },
});

export const matchInfo = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space["2xs"],
  width: "100%",
});

export const matchEntryAndScore = style({
  display: "flex",
  justifyContent: "center",
  gap: vars.space.m,
  width: "100%",
});

const knockoutNameBase = style({
  justifySelf: "center",
  fontSize: vars.fontSizes.body.s,
});

export const knockoutName = styleVariants({
  default: [knockoutNameBase],
  isFinal: [knockoutNameBase, { fontFamily: vars.fonts.bold, fontWeight: 400 }],
});

export const itemStatusContainer = style({
  paddingBottom: vars.space.s,
  selectors: {
    [`${listItemStyles.mine} &`]: {
      backgroundColor: vars.colors.glass,
    },
  },
});
